
namespace RioERP.Inventory {

    @Serenity.Decorators.registerClass()
    export class PendriveOutwardGrid extends Serenity.EntityGrid<PendriveOutwardRow, any> {
        protected getColumnsKey() { return PendriveOutwardColumns.columnsKey; }
        protected getDialogType() { return PendriveOutwardDialog; }
        protected getIdProperty() { return PendriveOutwardRow.idProperty; }
        protected getInsertPermission() { return PendriveOutwardRow.insertPermission; }
        protected getLocalTextPrefix() { return PendriveOutwardRow.localTextPrefix; }
        protected getService() { return PendriveOutwardService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}